import { EXTERIOR_WORLD } from "@catworld/shared";

const floor = EXTERIOR_WORLD.floor;
const heights = new Float32Array(floor.nx * floor.nz);
let cursor = 0;
for (let i = 0; i < floor.runs.length; i += 2) {
  const end = cursor + floor.runs[i + 1];
  if (end > heights.length) throw new Error("Exterior floor data overflows its grid");
  heights.fill(floor.runs[i], cursor, end);
  cursor = end;
}
if (cursor !== heights.length) throw new Error("Exterior floor data is incomplete");

/** Height of the exported Blender ground, including paving and creek banks.
 * @param {number} x @param {number} z */
export function exteriorGroundY(x, z) {
  const u = Math.max(0, Math.min(floor.nx - 1.000001, (x - floor.minX) / floor.step));
  const v = Math.max(0, Math.min(floor.nz - 1.000001, (z - floor.minZ) / floor.step));
  const i = Math.floor(u), j = Math.floor(v), tx = u - i, tz = v - j;
  const k = j * floor.nx + i;
  return (heights[k] * (1 - tx) + heights[k + 1] * tx) * (1 - tz)
    + (heights[k + floor.nx] * (1 - tx) + heights[k + floor.nx + 1] * tx) * tz;
}
